import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';
import { mapCheckIdIoAPI } from '../../services/HealthCheckService';



const HealthCheckJson = () => {
    const location = useLocation();
    const healthCheckId: string = location.pathname.split("/").pop() || "";
    const [healthJSON, setHealthJSON] = useState({})
    useEffect(() => {
        async function healthOBJGenerate() {
            const mapValue = await mapCheckIdIoAPI(healthCheckId)
            const healthCheckObjResponse = {
                serviceName: healthCheckId,
                url: mapValue.url,
                status: mapValue.status,
                critical: "Yes",
            };
            setHealthJSON(healthCheckObjResponse)
        }
        healthOBJGenerate()
    }, [])


    return (
        <pre>
            {JSON.stringify(healthJSON, null, 3)}
        </pre>
    )
}

export default HealthCheckJson